module.exports = __webpack_public_path__ + "img/zoom-out_bg-blue.caf22fe6.svg";